"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetMoreApps = exports.fetchMoreApps = exports.fetchDetails = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var ActionTypes = _interopRequireWildcard(require("./ActionTypes"));

var ecosystemClient = _interopRequireWildcard(require("../clients/ecosystemClient"));

var _immutable = _interopRequireDefault(require("immutable"));

var _ListingView = _interopRequireDefault(require("../records/ListingView"));

var _ThinListing = _interopRequireDefault(require("ecosystem-marketplace-core/records/ThinListing"));

var _earlyRequests = require("../utils/earlyRequests");

var _history = require("../utils/history");

var _groupTags = require("ecosystem-marketplace-core/utils/groupTags");

var _params = require("hub-http/helpers/params");

var CategorySlug = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/urlSlugs/CategorySlug"));

var SuperCategorySlug = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/urlSlugs/SuperCategorySlug"));

var validateDetailsUrl = function validateDetailsUrl(category, path, search, slug, isAdminPreview, isCustomer, activeCategory) {
  var _parseParams = (0, _params.parse)(search.slice(1)),
      published = _parseParams.published;

  var isPreview = published === 'false' || path === '/_preview/:slug' || isAdminPreview;
  var isShortlink = path.includes('/_detail/:slug');
  var isReviewLink = path.includes('/:slug/write-review');

  if (!isCustomer && isPreview && !isAdminPreview) {
    var publicPreviewError = new Error('Forbidden public preview');
    publicPreviewError.status = 403;
    throw publicPreviewError;
  }

  if (isShortlink) {
    var superCategory = category ? (0, _groupTags.getCategorySuperCategory)(category) : null;

    if (!(category && superCategory)) {
      var redirectError = new Error('Super category & category required to redirect');
      redirectError.status = 404;
      throw redirectError;
    }

    var superCategoryFacet = SuperCategorySlug[superCategory];
    var categoryFacet = CategorySlug[category];
    (0, _history.replace)("/" + superCategoryFacet + "/" + categoryFacet + "/" + slug + (isReviewLink ? '/write-review' : ''));
  }

  if (activeCategory && category !== activeCategory) {
    var categoryError = new Error('Invalid category slug');
    categoryError.status = 404;
    throw categoryError;
  }
};

var fetchDetails = function fetchDetails(slug, isPublished, isAdminPreview, _ref) {
  var path = _ref.path,
      search = _ref.search,
      isCustomer = _ref.isCustomer,
      activeCategory = _ref.activeCategory;
  return function (dispatch) {
    var meta = {
      slug: slug
    };
    dispatch({
      type: ActionTypes.DETAILS_FETCH_REQUESTED,
      meta: meta
    });
    return (0, _earlyRequests.maybeEarlyRequest)("details:" + slug, function () {
      return ecosystemClient.details(slug, isPublished, isAdminPreview);
    }).then(function (result) {
      var newListingView = new _ListingView.default(result);
      var category = newListingView.getCategory();
      validateDetailsUrl(category, path, search, slug, isAdminPreview, isCustomer, activeCategory);
      dispatch({
        type: ActionTypes.DETAILS_FETCH_RECEIVED,
        payload: newListingView,
        meta: meta
      });
    }).catch(function (error) {
      dispatch({
        type: ActionTypes.DETAILS_FETCH_FAILED,
        payload: error,
        meta: meta
      });
    });
  };
};

exports.fetchDetails = fetchDetails;

var fetchMoreApps = function fetchMoreApps(moreAppsQueries, slug) {
  return function (dispatch) {
    dispatch({
      type: ActionTypes.DETAILS_MORE_APPS_FETCH_REQUESTED
    });
    ecosystemClient.searchMulti(moreAppsQueries).then(function (_ref2) {
      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          _categoryResults = _ref3[0].items,
          _ref3$ = _ref3[1];

      _ref3$ = _ref3$ === void 0 ? {} : _ref3$;

      var _ref3$$items = _ref3$.items,
          _superCategoryResults = _ref3$$items === void 0 ? [] : _ref3$$items;

      var categoryResults = _categoryResults.filter(function (_ref4) {
        var _slug = _ref4.slug;
        return _slug !== slug;
      });

      var superCategoryResults = _superCategoryResults.filter(function (_ref5) {
        var _slug = _ref5.slug;
        return _slug !== slug;
      });

      var hasCategoryResults = !!categoryResults.length;
      var results = hasCategoryResults ? categoryResults : superCategoryResults;
      dispatch({
        type: ActionTypes.DETAILS_MORE_APPS_FETCH_RECEIVED,
        payload: new _immutable.default.Map({
          hasCategoryResults: hasCategoryResults,
          results: _immutable.default.OrderedSet(results.slice(0, 3).map(function (result) {
            return new _ThinListing.default(result);
          }))
        })
      });
    }).catch(function (__error) {
      dispatch({
        type: ActionTypes.DETAILS_MORE_APPS_FETCH_FAILED
      });
    });
  };
};

exports.fetchMoreApps = fetchMoreApps;

var resetMoreApps = function resetMoreApps() {
  return function (dispatch) {
    dispatch({
      type: ActionTypes.DETAILS_MORE_APPS_RESET
    });
  };
};

exports.resetMoreApps = resetMoreApps;


//////////////////
// WEBPACK FOOTER
// ./js/actions/DetailsActions.js
// module id = 378
// module chunks = 209 210 211 212